import { ValidationResult } from "lib/hooks/use-input";
import { emailRegex } from "lib/utils";

export const noDecimalsValidator = (v: number): ValidationResult => {
  if (v.toString().includes(".")) {
    return {
      valid: false,
      message: "Please enter a whole number",
    };
  }
  return { valid: true };
};
